module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Opgaver uden budget (" + _vm._s(_vm.rows ? _vm.rows.length : '-') + ")\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "searchOptions": _vm.searchOptions,
      "paginationOptions": _vm.paginationOptions,
      "sortOptions": _vm.sortOptions,
      "styleClass": "vgt-table"
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                    ")]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                    ")]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(props.row.status.name) + "\n                        "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 638086115)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4ad6705f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ad6705f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/components/projectsMissingBudget.vue
// module id = 830
// module chunks = 0